import CommonFunctions from "./CommonFunctions";

interface ResultType { }

export default class DropDownPlus {
    static dropDownPopupWindowIdStack = [];
    static dropDownPlusWindowIndex = -1;

    static getPopupWindowResult(): ResultType[] {
        return $(`#${DropDownPlus.dropDownPopupWindowIdStack[DropDownPlus.dropDownPlusWindowIndex]}`).data("popupWindowResult") || [];
    }

    // default result to value mapper
    static mapWindowResultToDropDownValue(windowResult) {
        if (windowResult && windowResult.length > 0) {
            //odata support ; always return array
            return windowResult.pop();
        }
        if (windowResult && typeof windowResult === "number") {
            //controller support, always return number
            return windowResult;
        }
        return undefined;
    }

    static openDropDownPlusWindow(url: string, title: string, dropDownId: string, resultToValueMapper: (result) => ([] | string) = DropDownPlus.mapWindowResultToDropDownValue): JQueryPromise<ResultType> {
        const deferred = jQuery.Deferred<ResultType>();
        $(`#${dropDownId}`).data().kendoDropDownList?.close();
        DropDownPlus.dropDownPopupWindowIdStack.push(`dropDownPlusWindow${DropDownPlus.dropDownPlusWindowIndex++}`);
        const wnd = CommonFunctions.openInModalWindow(DropDownPlus.dropDownPopupWindowIdStack[DropDownPlus.dropDownPlusWindowIndex], url, title, true, 800);
        wnd.one("close", () => {
            const dropDown: kendo.ui.DropDownList = $(`#${dropDownId}`).data().kendoDropDownList;
            const result = DropDownPlus.getPopupWindowResult();
            const value = resultToValueMapper(result);

            if (value != null) {
                dropDown.one("dataBound", () => {
                    dropDown.value(String(value));
                });
            }

            dropDown.dataSource.read()
                .then(() => deferred.resolve(result))
                .fail(() => deferred.reject());

            DropDownPlus.dropDownPopupWindowIdStack.pop();
            DropDownPlus.dropDownPlusWindowIndex--;
        });
        return deferred;
    }

    static dropDownPlusButtonClickHandler(button: kendo.ui.Button, url: string, title: string, dropDownId: string, resultToValueMapper: (result) => string | [] = DropDownPlus.mapWindowResultToDropDownValue) {
        button.enable(false);
        DropDownPlus.openDropDownPlusWindow(url, title, dropDownId, resultToValueMapper)
            .done(() => button.enable(true))
            .fail(() => console.error("openDropDownPlusWindow failed"));
    }

    static removeDataFromWindowResult(result) {
        const array = DropDownPlus.getPopupWindowResult().filter((item) => item !== result);
        $(`#${DropDownPlus.dropDownPopupWindowIdStack[DropDownPlus.dropDownPlusWindowIndex]}`).data("popupWindowResult", array);
    }

    static addDataToPopuWindowResult(result) {
        const array = DropDownPlus.getPopupWindowResult();
        array.push(result);
        $(`#${DropDownPlus.dropDownPopupWindowIdStack[DropDownPlus.dropDownPlusWindowIndex]}`).data("popupWindowResult", array);
    }

    static odataGridOnRequestEnd(e, valueField: string) {
        if (e.type === 'create') {
            DropDownPlus.addDataToPopuWindowResult(e.response[valueField]);
        } else if (e.type === 'destroy') {
            DropDownPlus.removeDataFromWindowResult(e.response.value);
        }
    }
}
